/* global globalThis */
import React, { useEffect } from 'react';
import { FALLBACK_TIMEOUT_MS } from './constants';
import {
  parseCallbackParams,
  buildScenePlusDeepLink,
  detectMobileOS,
  getStoreUrl,
} from './utils';

/**
 * Scene+ (Monarch) OAuth callback bridge.
 *
 * Rendered outside the market-gated app shell because Okta redirects here
 * without the query params the shell needs to bootstrap. When the OS verifies
 * the HTTPS deep link it routes the callback straight to the Shell App and this
 * page never runs. It only executes as the browser fallback: it hands the Okta
 * response to the app via the legacy custom scheme and, if that fails, sends the
 * user to the relevant app store after a short timeout.
 */
function ScenePlusCallback() {
  useEffect(() => {
    const deepLink = buildScenePlusDeepLink(
      parseCallbackParams(globalThis.location.search)
    );

    globalThis.location.assign(deepLink);

    const timer = globalThis.setTimeout(() => {
      // The app opened and backgrounded this tab - don't bounce to the store.
      if (document.hidden) {
        return;
      }

      const storeUrl = getStoreUrl(
        detectMobileOS(globalThis.navigator.userAgent)
      );
      if (storeUrl) {
        globalThis.location.assign(storeUrl);
      }
    }, FALLBACK_TIMEOUT_MS);

    return () => globalThis.clearTimeout(timer);
  }, []);

  return (
    <div
      data-testid="scene-plus-callback"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <span>Redirecting…</span>
    </div>
  );
}

export default ScenePlusCallback;
